var _rect, _path, _rect2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIrDoorsMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#001F97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3066 11.9999H16.3508M10.2933 8.86442L10.2999 8.08948M8.98275 5.33325H11.4574C12.1938 5.33325 12.7908 5.93021 12.7908 6.66659V10.1141V13.9485V17.3333C12.7908 18.0696 12.1938 18.6666 11.4574 18.6666H8.98275C8.24637 18.6666 7.64941 18.0696 7.64941 17.3333V6.66659C7.64941 5.93021 8.24637 5.33325 8.98275 5.33325Z",
    stroke: "white",
    strokeWidth: 1.32727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.2124,
    y: 4.78125,
    width: 5.20308,
    height: 5.09349,
    rx: 0.995455,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7634 5.74059V8.78125H15.1206V5.74059H15.7634ZM16.2924 8.78125V5.74059H17.492C17.7216 5.74059 17.9176 5.78166 18.0799 5.86382C18.2433 5.94498 18.3675 6.06029 18.4526 6.20975C18.5387 6.35822 18.5818 6.53292 18.5818 6.73385C18.5818 6.93577 18.5382 7.10948 18.4511 7.25498C18.364 7.39949 18.2378 7.51035 18.0725 7.58755C17.9082 7.66476 17.7093 7.70336 17.4757 7.70336H16.6725V7.18668H17.3717C17.4945 7.18668 17.5964 7.16986 17.6776 7.1362C17.7588 7.10255 17.8191 7.05207 17.8587 6.98476C17.8993 6.91746 17.9196 6.83382 17.9196 6.73385C17.9196 6.63289 17.8993 6.54777 17.8587 6.47848C17.8191 6.4092 17.7583 6.35674 17.6761 6.3211C17.5949 6.28448 17.4925 6.26617 17.3688 6.26617H16.9352V8.78125H16.2924ZM17.9344 7.39751L18.6902 8.78125H17.9805L17.2411 7.39751H17.9344Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrDoorsMarker);
export default __webpack_public_path__ + "static/media/IrDoorsMarker.097da532eac298a3d37b6a57104a7a43.svg";
export { ForwardRef as ReactComponent };